export const countryLookup = {
    AF: {
        Country: "Afghanistan",
        "Alpha-2 code": "AF",
        "Alpha-3 code": "AFG",
        "Numeric code": 4,
        "Latitude (average)": 33,
        "Longitude (average)": 65,
        emoji_flag: "🇦🇫"
    },
    AL: {
        Country: "Albania",
        "Alpha-2 code": "AL",
        "Alpha-3 code": "ALB",
        "Numeric code": 8,
        "Latitude (average)": 41,
        "Longitude (average)": 20,
        emoji_flag: "🇦🇱"
    },
    DZ: {
        Country: "Algeria",
        "Alpha-2 code": "DZ",
        "Alpha-3 code": "DZA",
        "Numeric code": 12,
        "Latitude (average)": 28,
        "Longitude (average)": 3,
        emoji_flag: "🇩🇿"
    },
    AS: {
        Country: "American Samoa",
        "Alpha-2 code": "AS",
        "Alpha-3 code": "ASM",
        "Numeric code": 16,
        "Latitude (average)": -14.3333,
        "Longitude (average)": -170,
        emoji_flag: "🇦🇸"
    },
    AD: {
        Country: "Andorra",
        "Alpha-2 code": "AD",
        "Alpha-3 code": "AND",
        "Numeric code": 20,
        "Latitude (average)": 42.5,
        "Longitude (average)": 1.6,
        emoji_flag: "🇦🇩"
    },
    AO: {
        Country: "Angola",
        "Alpha-2 code": "AO",
        "Alpha-3 code": "AGO",
        "Numeric code": 24,
        "Latitude (average)": -12.5,
        "Longitude (average)": 18.5,
        emoji_flag: "🇦🇴"
    },
    AI: {
        Country: "Anguilla",
        "Alpha-2 code": "AI",
        "Alpha-3 code": "AIA",
        "Numeric code": 660,
        "Latitude (average)": 18.25,
        "Longitude (average)": -63.1667,
        emoji_flag: "🇦🇮"
    },
    AQ: {
        Country: "Antarctica",
        "Alpha-2 code": "AQ",
        "Alpha-3 code": "ATA",
        "Numeric code": 10,
        "Latitude (average)": -90,
        "Longitude (average)": 0,
        emoji_flag: "🇦🇶"
    },
    AG: {
        Country: "Antigua and Barbuda",
        "Alpha-2 code": "AG",
        "Alpha-3 code": "ATG",
        "Numeric code": 28,
        "Latitude (average)": 17.05,
        "Longitude (average)": -61.8,
        emoji_flag: "🇦🇬"
    },
    AR: {
        Country: "Argentina",
        "Alpha-2 code": "AR",
        "Alpha-3 code": "ARG",
        "Numeric code": 32,
        "Latitude (average)": -34,
        "Longitude (average)": -64,
        emoji_flag: "🇦🇷"
    },
    AM: {
        Country: "Armenia",
        "Alpha-2 code": "AM",
        "Alpha-3 code": "ARM",
        "Numeric code": 51,
        "Latitude (average)": 40,
        "Longitude (average)": 45,
        emoji_flag: "🇦🇲"
    },
    AW: {
        Country: "Aruba",
        "Alpha-2 code": "AW",
        "Alpha-3 code": "ABW",
        "Numeric code": 533,
        "Latitude (average)": 12.5,
        "Longitude (average)": -69.9667,
        emoji_flag: "🇦🇼"
    },
    AU: {
        Country: "Australia",
        "Alpha-2 code": "AU",
        "Alpha-3 code": "AUS",
        "Numeric code": 36,
        "Latitude (average)": -27,
        "Longitude (average)": 133,
        emoji_flag: "🇦🇺"
    },
    AT: {
        Country: "Austria",
        "Alpha-2 code": "AT",
        "Alpha-3 code": "AUT",
        "Numeric code": 40,
        "Latitude (average)": 47.3333,
        "Longitude (average)": 13.3333,
        emoji_flag: "🇦🇹"
    },
    AZ: {
        Country: "Azerbaijan",
        "Alpha-2 code": "AZ",
        "Alpha-3 code": "AZE",
        "Numeric code": 31,
        "Latitude (average)": 40.5,
        "Longitude (average)": 47.5,
        emoji_flag: "🇦🇿"
    },
    BS: {
        Country: "Bahamas",
        "Alpha-2 code": "BS",
        "Alpha-3 code": "BHS",
        "Numeric code": 44,
        "Latitude (average)": 24.25,
        "Longitude (average)": -76,
        emoji_flag: "🇧🇸"
    },
    BH: {
        Country: "Bahrain",
        "Alpha-2 code": "BH",
        "Alpha-3 code": "BHR",
        "Numeric code": 48,
        "Latitude (average)": 26,
        "Longitude (average)": 50.55,
        emoji_flag: "🇧🇭"
    },
    BD: {
        Country: "Bangladesh",
        "Alpha-2 code": "BD",
        "Alpha-3 code": "BGD",
        "Numeric code": 50,
        "Latitude (average)": 24,
        "Longitude (average)": 90,
        emoji_flag: "🇧🇩"
    },
    BB: {
        Country: "Barbados",
        "Alpha-2 code": "BB",
        "Alpha-3 code": "BRB",
        "Numeric code": 52,
        "Latitude (average)": 13.1667,
        "Longitude (average)": -59.5333,
        emoji_flag: "🇧🇧"
    },
    BY: {
        Country: "Belarus",
        "Alpha-2 code": "BY",
        "Alpha-3 code": "BLR",
        "Numeric code": 112,
        "Latitude (average)": 53,
        "Longitude (average)": 28,
        emoji_flag: "🇧🇾"
    },
    BE: {
        Country: "Belgium",
        "Alpha-2 code": "BE",
        "Alpha-3 code": "BEL",
        "Numeric code": 56,
        "Latitude (average)": 50.8333,
        "Longitude (average)": 4,
        emoji_flag: "🇧🇪"
    },
    BZ: {
        Country: "Belize",
        "Alpha-2 code": "BZ",
        "Alpha-3 code": "BLZ",
        "Numeric code": 84,
        "Latitude (average)": 17.25,
        "Longitude (average)": -88.75,
        emoji_flag: "🇧🇿"
    },
    BJ: {
        Country: "Benin",
        "Alpha-2 code": "BJ",
        "Alpha-3 code": "BEN",
        "Numeric code": 204,
        "Latitude (average)": 9.5,
        "Longitude (average)": 2.25,
        emoji_flag: "🇧🇯"
    },
    BM: {
        Country: "Bermuda",
        "Alpha-2 code": "BM",
        "Alpha-3 code": "BMU",
        "Numeric code": 60,
        "Latitude (average)": 32.3333,
        "Longitude (average)": -64.75,
        emoji_flag: "🇧🇲"
    },
    BT: {
        Country: "Bhutan",
        "Alpha-2 code": "BT",
        "Alpha-3 code": "BTN",
        "Numeric code": 64,
        "Latitude (average)": 27.5,
        "Longitude (average)": 90.5,
        emoji_flag: "🇧🇹"
    },
    BO: {
        Country: "Bolivia",
        "Alpha-2 code": "BO",
        "Alpha-3 code": "BOL",
        "Numeric code": 68,
        "Latitude (average)": -17,
        "Longitude (average)": -65,
        emoji_flag: "🇧🇴"
    },
    BA: {
        Country: "Bosnia and Herzegovina",
        "Alpha-2 code": "BA",
        "Alpha-3 code": "BIH",
        "Numeric code": 70,
        "Latitude (average)": 44,
        "Longitude (average)": 18,
        emoji_flag: "🇧🇦"
    },
    BW: {
        Country: "Botswana",
        "Alpha-2 code": "BW",
        "Alpha-3 code": "BWA",
        "Numeric code": 72,
        "Latitude (average)": -22,
        "Longitude (average)": 24,
        emoji_flag: "🇧🇼"
    },
    BV: {
        Country: "Bouvet Island",
        "Alpha-2 code": "BV",
        "Alpha-3 code": "BVT",
        "Numeric code": 74,
        "Latitude (average)": -54.4333,
        "Longitude (average)": 3.4,
        emoji_flag: "🇧🇻"
    },
    BR: {
        Country: "Brazil",
        "Alpha-2 code": "BR",
        "Alpha-3 code": "BRA",
        "Numeric code": 76,
        "Latitude (average)": -10,
        "Longitude (average)": -55,
        emoji_flag: "🇧🇷"
    },
    IO: {
        Country: "British Indian Ocean Territory",
        "Alpha-2 code": "IO",
        "Alpha-3 code": "IOT",
        "Numeric code": 86,
        "Latitude (average)": -6,
        "Longitude (average)": 71.5,
        emoji_flag: "🇮🇴"
    },
    BN: {
        Country: "Brunei",
        "Alpha-2 code": "BN",
        "Alpha-3 code": "BRN",
        "Numeric code": 96,
        "Latitude (average)": 4.5,
        "Longitude (average)": 114.6667,
        emoji_flag: "🇧🇳"
    },
    BG: {
        Country: "Bulgaria",
        "Alpha-2 code": "BG",
        "Alpha-3 code": "BGR",
        "Numeric code": 100,
        "Latitude (average)": 43,
        "Longitude (average)": 25,
        emoji_flag: "🇧🇬"
    },
    BF: {
        Country: "Burkina Faso",
        "Alpha-2 code": "BF",
        "Alpha-3 code": "BFA",
        "Numeric code": 854,
        "Latitude (average)": 13,
        "Longitude (average)": -2,
        emoji_flag: "🇧🇫"
    },
    BI: {
        Country: "Burundi",
        "Alpha-2 code": "BI",
        "Alpha-3 code": "BDI",
        "Numeric code": 108,
        "Latitude (average)": -3.5,
        "Longitude (average)": 30,
        emoji_flag: "🇧🇮"
    },
    KH: {
        Country: "Cambodia",
        "Alpha-2 code": "KH",
        "Alpha-3 code": "KHM",
        "Numeric code": 116,
        "Latitude (average)": 13,
        "Longitude (average)": 105,
        emoji_flag: "🇰🇭"
    },
    CM: {
        Country: "Cameroon",
        "Alpha-2 code": "CM",
        "Alpha-3 code": "CMR",
        "Numeric code": 120,
        "Latitude (average)": 6,
        "Longitude (average)": 12,
        emoji_flag: "🇨🇲"
    },
    CA: {
        Country: "Canada",
        "Alpha-2 code": "CA",
        "Alpha-3 code": "CAN",
        "Numeric code": 124,
        "Latitude (average)": 60,
        "Longitude (average)": -95,
        emoji_flag: "🇨🇦"
    },
    CV: {
        Country: "Cape Verde",
        "Alpha-2 code": "CV",
        "Alpha-3 code": "CPV",
        "Numeric code": 132,
        "Latitude (average)": 16,
        "Longitude (average)": -24,
        emoji_flag: "🇨🇻"
    },
    KY: {
        Country: "Cayman Islands",
        "Alpha-2 code": "KY",
        "Alpha-3 code": "CYM",
        "Numeric code": 136,
        "Latitude (average)": 19.5,
        "Longitude (average)": -80.5,
        emoji_flag: "🇰🇾"
    },
    CF: {
        Country: "Central African Republic",
        "Alpha-2 code": "CF",
        "Alpha-3 code": "CAF",
        "Numeric code": 140,
        "Latitude (average)": 7,
        "Longitude (average)": 21,
        emoji_flag: "🇨🇫"
    },
    TD: {
        Country: "Chad",
        "Alpha-2 code": "TD",
        "Alpha-3 code": "TCD",
        "Numeric code": 148,
        "Latitude (average)": 15,
        "Longitude (average)": 19,
        emoji_flag: "🇹🇩"
    },
    CL: {
        Country: "Chile",
        "Alpha-2 code": "CL",
        "Alpha-3 code": "CHL",
        "Numeric code": 152,
        "Latitude (average)": -30,
        "Longitude (average)": -71,
        emoji_flag: "🇨🇱"
    },
    CN: {
        Country: "China",
        "Alpha-2 code": "CN",
        "Alpha-3 code": "CHN",
        "Numeric code": 156,
        "Latitude (average)": 35,
        "Longitude (average)": 105,
        emoji_flag: "🇨🇳"
    },
    CX: {
        Country: "Christmas Island",
        "Alpha-2 code": "CX",
        "Alpha-3 code": "CXR",
        "Numeric code": 162,
        "Latitude (average)": -10.5,
        "Longitude (average)": 105.6667,
        emoji_flag: "🇨🇽"
    },
    CC: {
        Country: "Cocos (Keeling) Islands",
        "Alpha-2 code": "CC",
        "Alpha-3 code": "CCK",
        "Numeric code": 166,
        "Latitude (average)": -12.5,
        "Longitude (average)": 96.8333,
        emoji_flag: "🇨🇨"
    },
    CO: {
        Country: "Colombia",
        "Alpha-2 code": "CO",
        "Alpha-3 code": "COL",
        "Numeric code": 170,
        "Latitude (average)": 4,
        "Longitude (average)": -72,
        emoji_flag: "🇨🇴"
    },
    KM: {
        Country: "Comoros",
        "Alpha-2 code": "KM",
        "Alpha-3 code": "COM",
        "Numeric code": 174,
        "Latitude (average)": -12.1667,
        "Longitude (average)": 44.25,
        emoji_flag: "🇰🇲"
    },
    CG: {
        Country: "Congo",
        "Alpha-2 code": "CG",
        "Alpha-3 code": "COG",
        "Numeric code": 178,
        "Latitude (average)": -1,
        "Longitude (average)": 15,
        emoji_flag: "🇨🇬"
    },
    CD: {
        Country: "Congo, the Democratic Republic of the",
        "Alpha-2 code": "CD",
        "Alpha-3 code": "COD",
        "Numeric code": 180,
        "Latitude (average)": 0,
        "Longitude (average)": 25,
        emoji_flag: "🇨🇩"
    },
    CK: {
        Country: "Cook Islands",
        "Alpha-2 code": "CK",
        "Alpha-3 code": "COK",
        "Numeric code": 184,
        "Latitude (average)": -21.2333,
        "Longitude (average)": -159.7667,
        emoji_flag: "🇨🇰"
    },
    CR: {
        Country: "Costa Rica",
        "Alpha-2 code": "CR",
        "Alpha-3 code": "CRI",
        "Numeric code": 188,
        "Latitude (average)": 10,
        "Longitude (average)": -84,
        emoji_flag: "🇨🇷"
    },
    CI: {
        Country: "Ivory Coast",
        "Alpha-2 code": "CI",
        "Alpha-3 code": "CIV",
        "Numeric code": 384,
        "Latitude (average)": 8,
        "Longitude (average)": -5,
        emoji_flag: "🇨🇮"
    },
    HR: {
        Country: "Croatia",
        "Alpha-2 code": "HR",
        "Alpha-3 code": "HRV",
        "Numeric code": 191,
        "Latitude (average)": 45.1667,
        "Longitude (average)": 15.5,
        emoji_flag: "🇭🇷"
    },
    CU: {
        Country: "Cuba",
        "Alpha-2 code": "CU",
        "Alpha-3 code": "CUB",
        "Numeric code": 192,
        "Latitude (average)": 21.5,
        "Longitude (average)": -80,
        emoji_flag: "🇨🇺"
    },
    CY: {
        Country: "Cyprus",
        "Alpha-2 code": "CY",
        "Alpha-3 code": "CYP",
        "Numeric code": 196,
        "Latitude (average)": 35,
        "Longitude (average)": 33,
        emoji_flag: "🇨🇾"
    },
    CZ: {
        Country: "Czech Republic",
        "Alpha-2 code": "CZ",
        "Alpha-3 code": "CZE",
        "Numeric code": 203,
        "Latitude (average)": 49.75,
        "Longitude (average)": 15.5,
        emoji_flag: "🇨🇿"
    },
    DK: {
        Country: "Denmark",
        "Alpha-2 code": "DK",
        "Alpha-3 code": "DNK",
        "Numeric code": 208,
        "Latitude (average)": 56,
        "Longitude (average)": 10,
        emoji_flag: "🇩🇰"
    },
    DJ: {
        Country: "Djibouti",
        "Alpha-2 code": "DJ",
        "Alpha-3 code": "DJI",
        "Numeric code": 262,
        "Latitude (average)": 11.5,
        "Longitude (average)": 43,
        emoji_flag: "🇩🇯"
    },
    DM: {
        Country: "Dominica",
        "Alpha-2 code": "DM",
        "Alpha-3 code": "DMA",
        "Numeric code": 212,
        "Latitude (average)": 15.4167,
        "Longitude (average)": -61.3333,
        emoji_flag: "🇩🇲"
    },
    DO: {
        Country: "Dominican Republic",
        "Alpha-2 code": "DO",
        "Alpha-3 code": "DOM",
        "Numeric code": 214,
        "Latitude (average)": 19,
        "Longitude (average)": -70.6667,
        emoji_flag: "🇩🇴"
    },
    EC: {
        Country: "Ecuador",
        "Alpha-2 code": "EC",
        "Alpha-3 code": "ECU",
        "Numeric code": 218,
        "Latitude (average)": -2,
        "Longitude (average)": -77.5,
        emoji_flag: "🇪🇨"
    },
    EG: {
        Country: "Egypt",
        "Alpha-2 code": "EG",
        "Alpha-3 code": "EGY",
        "Numeric code": 818,
        "Latitude (average)": 27,
        "Longitude (average)": 30,
        emoji_flag: "🇪🇬"
    },
    SV: {
        Country: "El Salvador",
        "Alpha-2 code": "SV",
        "Alpha-3 code": "SLV",
        "Numeric code": 222,
        "Latitude (average)": 13.8333,
        "Longitude (average)": -88.9167,
        emoji_flag: "🇸🇻"
    },
    GQ: {
        Country: "Equatorial Guinea",
        "Alpha-2 code": "GQ",
        "Alpha-3 code": "GNQ",
        "Numeric code": 226,
        "Latitude (average)": 2,
        "Longitude (average)": 10,
        emoji_flag: "🇬🇶"
    },
    ER: {
        Country: "Eritrea",
        "Alpha-2 code": "ER",
        "Alpha-3 code": "ERI",
        "Numeric code": 232,
        "Latitude (average)": 15,
        "Longitude (average)": 39,
        emoji_flag: "🇪🇷"
    },
    EE: {
        Country: "Estonia",
        "Alpha-2 code": "EE",
        "Alpha-3 code": "EST",
        "Numeric code": 233,
        "Latitude (average)": 59,
        "Longitude (average)": 26,
        emoji_flag: "🇪🇪"
    },
    ET: {
        Country: "Ethiopia",
        "Alpha-2 code": "ET",
        "Alpha-3 code": "ETH",
        "Numeric code": 231,
        "Latitude (average)": 8,
        "Longitude (average)": 38,
        emoji_flag: "🇪🇹"
    },
    FK: {
        Country: "Falkland Islands (Malvinas)",
        "Alpha-2 code": "FK",
        "Alpha-3 code": "FLK",
        "Numeric code": 238,
        "Latitude (average)": -51.75,
        "Longitude (average)": -59,
        emoji_flag: "🇫🇰"
    },
    FO: {
        Country: "Faroe Islands",
        "Alpha-2 code": "FO",
        "Alpha-3 code": "FRO",
        "Numeric code": 234,
        "Latitude (average)": 62,
        "Longitude (average)": -7,
        emoji_flag: "🇫🇴"
    },
    FJ: {
        Country: "Fiji",
        "Alpha-2 code": "FJ",
        "Alpha-3 code": "FJI",
        "Numeric code": 242,
        "Latitude (average)": -18,
        "Longitude (average)": 175,
        emoji_flag: "🇫🇯"
    },
    FI: {
        Country: "Finland",
        "Alpha-2 code": "FI",
        "Alpha-3 code": "FIN",
        "Numeric code": 246,
        "Latitude (average)": 64,
        "Longitude (average)": 26,
        emoji_flag: "🇫🇮"
    },
    FR: {
        Country: "France",
        "Alpha-2 code": "FR",
        "Alpha-3 code": "FRA",
        "Numeric code": 250,
        "Latitude (average)": 46,
        "Longitude (average)": 2,
        emoji_flag: "🇫🇷"
    },
    GF: {
        Country: "French Guiana",
        "Alpha-2 code": "GF",
        "Alpha-3 code": "GUF",
        "Numeric code": 254,
        "Latitude (average)": 4,
        "Longitude (average)": -53,
        emoji_flag: "🇬🇫"
    },
    PF: {
        Country: "French Polynesia",
        "Alpha-2 code": "PF",
        "Alpha-3 code": "PYF",
        "Numeric code": 258,
        "Latitude (average)": -15,
        "Longitude (average)": -140,
        emoji_flag: "🇵🇫"
    },
    TF: {
        Country: "French Southern Territories",
        "Alpha-2 code": "TF",
        "Alpha-3 code": "ATF",
        "Numeric code": 260,
        "Latitude (average)": -43,
        "Longitude (average)": 67,
        emoji_flag: "🇹🇫"
    },
    GA: {
        Country: "Gabon",
        "Alpha-2 code": "GA",
        "Alpha-3 code": "GAB",
        "Numeric code": 266,
        "Latitude (average)": -1,
        "Longitude (average)": 11.75,
        emoji_flag: "🇬🇦"
    },
    GM: {
        Country: "Gambia",
        "Alpha-2 code": "GM",
        "Alpha-3 code": "GMB",
        "Numeric code": 270,
        "Latitude (average)": 13.4667,
        "Longitude (average)": -16.5667,
        emoji_flag: "🇬🇲"
    },
    GE: {
        Country: "Georgia",
        "Alpha-2 code": "GE",
        "Alpha-3 code": "GEO",
        "Numeric code": 268,
        "Latitude (average)": 42,
        "Longitude (average)": 43.5,
        emoji_flag: "🇬🇪"
    },
    DE: {
        Country: "Germany",
        "Alpha-2 code": "DE",
        "Alpha-3 code": "DEU",
        "Numeric code": 276,
        "Latitude (average)": 51,
        "Longitude (average)": 9,
        emoji_flag: "🇩🇪"
    },
    GH: {
        Country: "Ghana",
        "Alpha-2 code": "GH",
        "Alpha-3 code": "GHA",
        "Numeric code": 288,
        "Latitude (average)": 8,
        "Longitude (average)": -2,
        emoji_flag: "🇬🇭"
    },
    GI: {
        Country: "Gibraltar",
        "Alpha-2 code": "GI",
        "Alpha-3 code": "GIB",
        "Numeric code": 292,
        "Latitude (average)": 36.1833,
        "Longitude (average)": -5.3667,
        emoji_flag: "🇬🇮"
    },
    GR: {
        Country: "Greece",
        "Alpha-2 code": "GR",
        "Alpha-3 code": "GRC",
        "Numeric code": 300,
        "Latitude (average)": 39,
        "Longitude (average)": 22,
        emoji_flag: "🇬🇷"
    },
    GL: {
        Country: "Greenland",
        "Alpha-2 code": "GL",
        "Alpha-3 code": "GRL",
        "Numeric code": 304,
        "Latitude (average)": 72,
        "Longitude (average)": -40,
        emoji_flag: "🇬🇱"
    },
    GD: {
        Country: "Grenada",
        "Alpha-2 code": "GD",
        "Alpha-3 code": "GRD",
        "Numeric code": 308,
        "Latitude (average)": 12.1167,
        "Longitude (average)": -61.6667,
        emoji_flag: "🇬🇩"
    },
    GP: {
        Country: "Guadeloupe",
        "Alpha-2 code": "GP",
        "Alpha-3 code": "GLP",
        "Numeric code": 312,
        "Latitude (average)": 16.25,
        "Longitude (average)": -61.5833,
        emoji_flag: "🇬🇵"
    },
    GU: {
        Country: "Guam",
        "Alpha-2 code": "GU",
        "Alpha-3 code": "GUM",
        "Numeric code": 316,
        "Latitude (average)": 13.4667,
        "Longitude (average)": 144.7833,
        emoji_flag: "🇬🇺"
    },
    GT: {
        Country: "Guatemala",
        "Alpha-2 code": "GT",
        "Alpha-3 code": "GTM",
        "Numeric code": 320,
        "Latitude (average)": 15.5,
        "Longitude (average)": -90.25,
        emoji_flag: "🇬🇹"
    },
    GG: {
        Country: "Guernsey",
        "Alpha-2 code": "GG",
        "Alpha-3 code": "GGY",
        "Numeric code": 831,
        "Latitude (average)": 49.5,
        "Longitude (average)": -2.56,
        emoji_flag: "🇬🇬"
    },
    GN: {
        Country: "Guinea",
        "Alpha-2 code": "GN",
        "Alpha-3 code": "GIN",
        "Numeric code": 324,
        "Latitude (average)": 11,
        "Longitude (average)": -10,
        emoji_flag: "🇬🇳"
    },
    GW: {
        Country: "Guinea-Bissau",
        "Alpha-2 code": "GW",
        "Alpha-3 code": "GNB",
        "Numeric code": 624,
        "Latitude (average)": 12,
        "Longitude (average)": -15,
        emoji_flag: "🇬🇼"
    },
    GY: {
        Country: "Guyana",
        "Alpha-2 code": "GY",
        "Alpha-3 code": "GUY",
        "Numeric code": 328,
        "Latitude (average)": 5,
        "Longitude (average)": -59,
        emoji_flag: "🇬🇾"
    },
    HT: {
        Country: "Haiti",
        "Alpha-2 code": "HT",
        "Alpha-3 code": "HTI",
        "Numeric code": 332,
        "Latitude (average)": 19,
        "Longitude (average)": -72.4167,
        emoji_flag: "🇭🇹"
    },
    HM: {
        Country: "Heard Island and McDonald Islands",
        "Alpha-2 code": "HM",
        "Alpha-3 code": "HMD",
        "Numeric code": 334,
        "Latitude (average)": -53.1,
        "Longitude (average)": 72.5167,
        emoji_flag: "🇭🇲"
    },
    VA: {
        Country: "Holy See (Vatican City State)",
        "Alpha-2 code": "VA",
        "Alpha-3 code": "VAT",
        "Numeric code": 336,
        "Latitude (average)": 41.9,
        "Longitude (average)": 12.45,
        emoji_flag: "🇻🇦"
    },
    HN: {
        Country: "Honduras",
        "Alpha-2 code": "HN",
        "Alpha-3 code": "HND",
        "Numeric code": 340,
        "Latitude (average)": 15,
        "Longitude (average)": -86.5,
        emoji_flag: "🇭🇳"
    },
    HK: {
        Country: "Hong Kong",
        "Alpha-2 code": "HK",
        "Alpha-3 code": "HKG",
        "Numeric code": 344,
        "Latitude (average)": 22.25,
        "Longitude (average)": 114.1667,
        emoji_flag: "🇭🇰"
    },
    HU: {
        Country: "Hungary",
        "Alpha-2 code": "HU",
        "Alpha-3 code": "HUN",
        "Numeric code": 348,
        "Latitude (average)": 47,
        "Longitude (average)": 20,
        emoji_flag: "🇭🇺"
    },
    IS: {
        Country: "Iceland",
        "Alpha-2 code": "IS",
        "Alpha-3 code": "ISL",
        "Numeric code": 352,
        "Latitude (average)": 65,
        "Longitude (average)": -18,
        emoji_flag: "🇮🇸"
    },
    IN: {
        Country: "India",
        "Alpha-2 code": "IN",
        "Alpha-3 code": "IND",
        "Numeric code": 356,
        "Latitude (average)": 20,
        "Longitude (average)": 77,
        emoji_flag: "🇮🇳"
    },
    ID: {
        Country: "Indonesia",
        "Alpha-2 code": "ID",
        "Alpha-3 code": "IDN",
        "Numeric code": 360,
        "Latitude (average)": -5,
        "Longitude (average)": 120,
        emoji_flag: "🇮🇩"
    },
    IR: {
        Country: "Iran, Islamic Republic of",
        "Alpha-2 code": "IR",
        "Alpha-3 code": "IRN",
        "Numeric code": 364,
        "Latitude (average)": 32,
        "Longitude (average)": 53,
        emoji_flag: "🇮🇷"
    },
    IQ: {
        Country: "Iraq",
        "Alpha-2 code": "IQ",
        "Alpha-3 code": "IRQ",
        "Numeric code": 368,
        "Latitude (average)": 33,
        "Longitude (average)": 44,
        emoji_flag: "🇮🇶"
    },
    IE: {
        Country: "Ireland",
        "Alpha-2 code": "IE",
        "Alpha-3 code": "IRL",
        "Numeric code": 372,
        "Latitude (average)": 53,
        "Longitude (average)": -8,
        emoji_flag: "🇮🇪"
    },
    IM: {
        Country: "Isle of Man",
        "Alpha-2 code": "IM",
        "Alpha-3 code": "IMN",
        "Numeric code": 833,
        "Latitude (average)": 54.23,
        "Longitude (average)": -4.55,
        emoji_flag: "🇮🇲"
    },
    IL: {
        Country: "Israel",
        "Alpha-2 code": "IL",
        "Alpha-3 code": "ISR",
        "Numeric code": 376,
        "Latitude (average)": 31.5,
        "Longitude (average)": 34.75,
        emoji_flag: "🇮🇱"
    },
    IT: {
        Country: "Italy",
        "Alpha-2 code": "IT",
        "Alpha-3 code": "ITA",
        "Numeric code": 380,
        "Latitude (average)": 42.8333,
        "Longitude (average)": 12.8333,
        emoji_flag: "🇮🇹"
    },
    JM: {
        Country: "Jamaica",
        "Alpha-2 code": "JM",
        "Alpha-3 code": "JAM",
        "Numeric code": 388,
        "Latitude (average)": 18.25,
        "Longitude (average)": -77.5,
        emoji_flag: "🇯🇲"
    },
    JP: {
        Country: "Japan",
        "Alpha-2 code": "JP",
        "Alpha-3 code": "JPN",
        "Numeric code": 392,
        "Latitude (average)": 36,
        "Longitude (average)": 138,
        emoji_flag: "🇯🇵"
    },
    JE: {
        Country: "Jersey",
        "Alpha-2 code": "JE",
        "Alpha-3 code": "JEY",
        "Numeric code": 832,
        "Latitude (average)": 49.21,
        "Longitude (average)": -2.13,
        emoji_flag: "🇯🇪"
    },
    JO: {
        Country: "Jordan",
        "Alpha-2 code": "JO",
        "Alpha-3 code": "JOR",
        "Numeric code": 400,
        "Latitude (average)": 31,
        "Longitude (average)": 36,
        emoji_flag: "🇯🇴"
    },
    KZ: {
        Country: "Kazakhstan",
        "Alpha-2 code": "KZ",
        "Alpha-3 code": "KAZ",
        "Numeric code": 398,
        "Latitude (average)": 48,
        "Longitude (average)": 68,
        emoji_flag: "🇰🇿"
    },
    KE: {
        Country: "Kenya",
        "Alpha-2 code": "KE",
        "Alpha-3 code": "KEN",
        "Numeric code": 404,
        "Latitude (average)": 1,
        "Longitude (average)": 38,
        emoji_flag: "🇰🇪"
    },
    KI: {
        Country: "Kiribati",
        "Alpha-2 code": "KI",
        "Alpha-3 code": "KIR",
        "Numeric code": 296,
        "Latitude (average)": 1.4167,
        "Longitude (average)": 173,
        emoji_flag: "🇰🇮"
    },
    KP: {
        Country: "Korea, Democratic People's Republic of",
        "Alpha-2 code": "KP",
        "Alpha-3 code": "PRK",
        "Numeric code": 408,
        "Latitude (average)": 40,
        "Longitude (average)": 127,
        emoji_flag: "🇰🇵"
    },
    KR: {
        Country: "South Korea",
        "Alpha-2 code": "KR",
        "Alpha-3 code": "KOR",
        "Numeric code": 410,
        "Latitude (average)": 37,
        "Longitude (average)": 127.5,
        emoji_flag: "🇰🇷"
    },
    KW: {
        Country: "Kuwait",
        "Alpha-2 code": "KW",
        "Alpha-3 code": "KWT",
        "Numeric code": 414,
        "Latitude (average)": 29.3375,
        "Longitude (average)": 47.6581,
        emoji_flag: "🇰🇼"
    },
    KG: {
        Country: "Kyrgyzstan",
        "Alpha-2 code": "KG",
        "Alpha-3 code": "KGZ",
        "Numeric code": 417,
        "Latitude (average)": 41,
        "Longitude (average)": 75,
        emoji_flag: "🇰🇬"
    },
    LA: {
        Country: "Lao People's Democratic Republic",
        "Alpha-2 code": "LA",
        "Alpha-3 code": "LAO",
        "Numeric code": 418,
        "Latitude (average)": 18,
        "Longitude (average)": 105,
        emoji_flag: "🇱🇦"
    },
    LV: {
        Country: "Latvia",
        "Alpha-2 code": "LV",
        "Alpha-3 code": "LVA",
        "Numeric code": 428,
        "Latitude (average)": 57,
        "Longitude (average)": 25,
        emoji_flag: "🇱🇻"
    },
    LB: {
        Country: "Lebanon",
        "Alpha-2 code": "LB",
        "Alpha-3 code": "LBN",
        "Numeric code": 422,
        "Latitude (average)": 33.8333,
        "Longitude (average)": 35.8333,
        emoji_flag: "🇱🇧"
    },
    LS: {
        Country: "Lesotho",
        "Alpha-2 code": "LS",
        "Alpha-3 code": "LSO",
        "Numeric code": 426,
        "Latitude (average)": -29.5,
        "Longitude (average)": 28.5,
        emoji_flag: "🇱🇸"
    },
    LR: {
        Country: "Liberia",
        "Alpha-2 code": "LR",
        "Alpha-3 code": "LBR",
        "Numeric code": 430,
        "Latitude (average)": 6.5,
        "Longitude (average)": -9.5,
        emoji_flag: "🇱🇷"
    },
    LY: {
        Country: "Libya",
        "Alpha-2 code": "LY",
        "Alpha-3 code": "LBY",
        "Numeric code": 434,
        "Latitude (average)": 25,
        "Longitude (average)": 17,
        emoji_flag: "🇱🇾"
    },
    LI: {
        Country: "Liechtenstein",
        "Alpha-2 code": "LI",
        "Alpha-3 code": "LIE",
        "Numeric code": 438,
        "Latitude (average)": 47.1667,
        "Longitude (average)": 9.5333,
        emoji_flag: "🇱🇮"
    },
    LT: {
        Country: "Lithuania",
        "Alpha-2 code": "LT",
        "Alpha-3 code": "LTU",
        "Numeric code": 440,
        "Latitude (average)": 56,
        "Longitude (average)": 24,
        emoji_flag: "🇱🇹"
    },
    LU: {
        Country: "Luxembourg",
        "Alpha-2 code": "LU",
        "Alpha-3 code": "LUX",
        "Numeric code": 442,
        "Latitude (average)": 49.75,
        "Longitude (average)": 6.1667,
        emoji_flag: "🇱🇺"
    },
    MO: {
        Country: "Macao",
        "Alpha-2 code": "MO",
        "Alpha-3 code": "MAC",
        "Numeric code": 446,
        "Latitude (average)": 22.1667,
        "Longitude (average)": 113.55,
        emoji_flag: "🇲🇴"
    },
    MK: {
        Country: "Macedonia, the former Yugoslav Republic of",
        "Alpha-2 code": "MK",
        "Alpha-3 code": "MKD",
        "Numeric code": 807,
        "Latitude (average)": 41.8333,
        "Longitude (average)": 22,
        emoji_flag: "🇲🇰"
    },
    MG: {
        Country: "Madagascar",
        "Alpha-2 code": "MG",
        "Alpha-3 code": "MDG",
        "Numeric code": 450,
        "Latitude (average)": -20,
        "Longitude (average)": 47,
        emoji_flag: "🇲🇬"
    },
    MW: {
        Country: "Malawi",
        "Alpha-2 code": "MW",
        "Alpha-3 code": "MWI",
        "Numeric code": 454,
        "Latitude (average)": -13.5,
        "Longitude (average)": 34,
        emoji_flag: "🇲🇼"
    },
    MY: {
        Country: "Malaysia",
        "Alpha-2 code": "MY",
        "Alpha-3 code": "MYS",
        "Numeric code": 458,
        "Latitude (average)": 2.5,
        "Longitude (average)": 112.5,
        emoji_flag: "🇲🇾"
    },
    MV: {
        Country: "Maldives",
        "Alpha-2 code": "MV",
        "Alpha-3 code": "MDV",
        "Numeric code": 462,
        "Latitude (average)": 3.25,
        "Longitude (average)": 73,
        emoji_flag: "🇲🇻"
    },
    ML: {
        Country: "Mali",
        "Alpha-2 code": "ML",
        "Alpha-3 code": "MLI",
        "Numeric code": 466,
        "Latitude (average)": 17,
        "Longitude (average)": -4,
        emoji_flag: "🇲🇱"
    },
    MT: {
        Country: "Malta",
        "Alpha-2 code": "MT",
        "Alpha-3 code": "MLT",
        "Numeric code": 470,
        "Latitude (average)": 35.8333,
        "Longitude (average)": 14.5833,
        emoji_flag: "🇲🇹"
    },
    MH: {
        Country: "Marshall Islands",
        "Alpha-2 code": "MH",
        "Alpha-3 code": "MHL",
        "Numeric code": 584,
        "Latitude (average)": 9,
        "Longitude (average)": 168,
        emoji_flag: "🇲🇭"
    },
    MQ: {
        Country: "Martinique",
        "Alpha-2 code": "MQ",
        "Alpha-3 code": "MTQ",
        "Numeric code": 474,
        "Latitude (average)": 14.6667,
        "Longitude (average)": -61,
        emoji_flag: "🇲🇶"
    },
    MR: {
        Country: "Mauritania",
        "Alpha-2 code": "MR",
        "Alpha-3 code": "MRT",
        "Numeric code": 478,
        "Latitude (average)": 20,
        "Longitude (average)": -12,
        emoji_flag: "🇲🇷"
    },
    MU: {
        Country: "Mauritius",
        "Alpha-2 code": "MU",
        "Alpha-3 code": "MUS",
        "Numeric code": 480,
        "Latitude (average)": -20.2833,
        "Longitude (average)": 57.55,
        emoji_flag: "🇲🇺"
    },
    YT: {
        Country: "Mayotte",
        "Alpha-2 code": "YT",
        "Alpha-3 code": "MYT",
        "Numeric code": 175,
        "Latitude (average)": -12.8333,
        "Longitude (average)": 45.1667,
        emoji_flag: "🇾🇹"
    },
    MX: {
        Country: "Mexico",
        "Alpha-2 code": "MX",
        "Alpha-3 code": "MEX",
        "Numeric code": 484,
        "Latitude (average)": 23,
        "Longitude (average)": -102,
        emoji_flag: "🇲🇽"
    },
    FM: {
        Country: "Micronesia, Federated States of",
        "Alpha-2 code": "FM",
        "Alpha-3 code": "FSM",
        "Numeric code": 583,
        "Latitude (average)": 6.9167,
        "Longitude (average)": 158.25,
        emoji_flag: "🇫🇲"
    },
    MD: {
        Country: "Moldova, Republic of",
        "Alpha-2 code": "MD",
        "Alpha-3 code": "MDA",
        "Numeric code": 498,
        "Latitude (average)": 47,
        "Longitude (average)": 29,
        emoji_flag: "🇲🇩"
    },
    MC: {
        Country: "Monaco",
        "Alpha-2 code": "MC",
        "Alpha-3 code": "MCO",
        "Numeric code": 492,
        "Latitude (average)": 43.7333,
        "Longitude (average)": 7.4,
        emoji_flag: "🇲🇨"
    },
    MN: {
        Country: "Mongolia",
        "Alpha-2 code": "MN",
        "Alpha-3 code": "MNG",
        "Numeric code": 496,
        "Latitude (average)": 46,
        "Longitude (average)": 105,
        emoji_flag: "🇲🇳"
    },
    ME: {
        Country: "Montenegro",
        "Alpha-2 code": "ME",
        "Alpha-3 code": "MNE",
        "Numeric code": 499,
        "Latitude (average)": 42,
        "Longitude (average)": 19,
        emoji_flag: "🇲🇪"
    },
    MS: {
        Country: "Montserrat",
        "Alpha-2 code": "MS",
        "Alpha-3 code": "MSR",
        "Numeric code": 500,
        "Latitude (average)": 16.75,
        "Longitude (average)": -62.2,
        emoji_flag: "🇲🇸"
    },
    MA: {
        Country: "Morocco",
        "Alpha-2 code": "MA",
        "Alpha-3 code": "MAR",
        "Numeric code": 504,
        "Latitude (average)": 32,
        "Longitude (average)": -5,
        emoji_flag: "🇲🇦"
    },
    MZ: {
        Country: "Mozambique",
        "Alpha-2 code": "MZ",
        "Alpha-3 code": "MOZ",
        "Numeric code": 508,
        "Latitude (average)": -18.25,
        "Longitude (average)": 35,
        emoji_flag: "🇲🇿"
    },
    MM: {
        Country: "Myanmar",
        "Alpha-2 code": "MM",
        "Alpha-3 code": "MMR",
        "Numeric code": 104,
        "Latitude (average)": 22,
        "Longitude (average)": 98,
        emoji_flag: "🇲🇲"
    },
    NA: {
        Country: "Namibia",
        "Alpha-2 code": "NA",
        "Alpha-3 code": "NAM",
        "Numeric code": 516,
        "Latitude (average)": -22,
        "Longitude (average)": 17,
        emoji_flag: "🇳🇦"
    },
    NR: {
        Country: "Nauru",
        "Alpha-2 code": "NR",
        "Alpha-3 code": "NRU",
        "Numeric code": 520,
        "Latitude (average)": -0.5333,
        "Longitude (average)": 166.9167,
        emoji_flag: "🇳🇷"
    },
    NP: {
        Country: "Nepal",
        "Alpha-2 code": "NP",
        "Alpha-3 code": "NPL",
        "Numeric code": 524,
        "Latitude (average)": 28,
        "Longitude (average)": 84,
        emoji_flag: "🇳🇵"
    },
    NL: {
        Country: "Netherlands",
        "Alpha-2 code": "NL",
        "Alpha-3 code": "NLD",
        "Numeric code": 528,
        "Latitude (average)": 52.5,
        "Longitude (average)": 5.75,
        emoji_flag: "🇳🇱"
    },
    AN: {
        Country: "Netherlands Antilles",
        "Alpha-2 code": "AN",
        "Alpha-3 code": "ANT",
        "Numeric code": 530,
        "Latitude (average)": 12.25,
        "Longitude (average)": -68.75,
        emoji_flag: "🇦🇳"
    },
    NC: {
        Country: "New Caledonia",
        "Alpha-2 code": "NC",
        "Alpha-3 code": "NCL",
        "Numeric code": 540,
        "Latitude (average)": -21.5,
        "Longitude (average)": 165.5,
        emoji_flag: "🇳🇨"
    },
    NZ: {
        Country: "New Zealand",
        "Alpha-2 code": "NZ",
        "Alpha-3 code": "NZL",
        "Numeric code": 554,
        "Latitude (average)": -41,
        "Longitude (average)": 174,
        emoji_flag: "🇳🇿"
    },
    NI: {
        Country: "Nicaragua",
        "Alpha-2 code": "NI",
        "Alpha-3 code": "NIC",
        "Numeric code": 558,
        "Latitude (average)": 13,
        "Longitude (average)": -85,
        emoji_flag: "🇳🇮"
    },
    NE: {
        Country: "Niger",
        "Alpha-2 code": "NE",
        "Alpha-3 code": "NER",
        "Numeric code": 562,
        "Latitude (average)": 16,
        "Longitude (average)": 8,
        emoji_flag: "🇳🇪"
    },
    NG: {
        Country: "Nigeria",
        "Alpha-2 code": "NG",
        "Alpha-3 code": "NGA",
        "Numeric code": 566,
        "Latitude (average)": 10,
        "Longitude (average)": 8,
        emoji_flag: "🇳🇬"
    },
    NU: {
        Country: "Niue",
        "Alpha-2 code": "NU",
        "Alpha-3 code": "NIU",
        "Numeric code": 570,
        "Latitude (average)": -19.0333,
        "Longitude (average)": -169.8667,
        emoji_flag: "🇳🇺"
    },
    NF: {
        Country: "Norfolk Island",
        "Alpha-2 code": "NF",
        "Alpha-3 code": "NFK",
        "Numeric code": 574,
        "Latitude (average)": -29.0333,
        "Longitude (average)": 167.95,
        emoji_flag: "🇳🇫"
    },
    MP: {
        Country: "Northern Mariana Islands",
        "Alpha-2 code": "MP",
        "Alpha-3 code": "MNP",
        "Numeric code": 580,
        "Latitude (average)": 15.2,
        "Longitude (average)": 145.75,
        emoji_flag: "🇲🇵"
    },
    NO: {
        Country: "Norway",
        "Alpha-2 code": "NO",
        "Alpha-3 code": "NOR",
        "Numeric code": 578,
        "Latitude (average)": 62,
        "Longitude (average)": 10,
        emoji_flag: "🇳🇴"
    },
    OM: {
        Country: "Oman",
        "Alpha-2 code": "OM",
        "Alpha-3 code": "OMN",
        "Numeric code": 512,
        "Latitude (average)": 21,
        "Longitude (average)": 57,
        emoji_flag: "🇴🇲"
    },
    PK: {
        Country: "Pakistan",
        "Alpha-2 code": "PK",
        "Alpha-3 code": "PAK",
        "Numeric code": 586,
        "Latitude (average)": 30,
        "Longitude (average)": 70,
        emoji_flag: "🇵🇰"
    },
    PW: {
        Country: "Palau",
        "Alpha-2 code": "PW",
        "Alpha-3 code": "PLW",
        "Numeric code": 585,
        "Latitude (average)": 7.5,
        "Longitude (average)": 134.5,
        emoji_flag: "🇵🇼"
    },
    PS: {
        Country: "Palestinian Territory, Occupied",
        "Alpha-2 code": "PS",
        "Alpha-3 code": "PSE",
        "Numeric code": 275,
        "Latitude (average)": 32,
        "Longitude (average)": 35.25,
        emoji_flag: "🇵🇸"
    },
    PA: {
        Country: "Panama",
        "Alpha-2 code": "PA",
        "Alpha-3 code": "PAN",
        "Numeric code": 591,
        "Latitude (average)": 9,
        "Longitude (average)": -80,
        emoji_flag: "🇵🇦"
    },
    PG: {
        Country: "Papua New Guinea",
        "Alpha-2 code": "PG",
        "Alpha-3 code": "PNG",
        "Numeric code": 598,
        "Latitude (average)": -6,
        "Longitude (average)": 147,
        emoji_flag: "🇵🇬"
    },
    PY: {
        Country: "Paraguay",
        "Alpha-2 code": "PY",
        "Alpha-3 code": "PRY",
        "Numeric code": 600,
        "Latitude (average)": -23,
        "Longitude (average)": -58,
        emoji_flag: "🇵🇾"
    },
    PE: {
        Country: "Peru",
        "Alpha-2 code": "PE",
        "Alpha-3 code": "PER",
        "Numeric code": 604,
        "Latitude (average)": -10,
        "Longitude (average)": -76,
        emoji_flag: "🇵🇪"
    },
    PH: {
        Country: "Philippines",
        "Alpha-2 code": "PH",
        "Alpha-3 code": "PHL",
        "Numeric code": 608,
        "Latitude (average)": 13,
        "Longitude (average)": 122,
        emoji_flag: "🇵🇭"
    },
    PN: {
        Country: "Pitcairn",
        "Alpha-2 code": "PN",
        "Alpha-3 code": "PCN",
        "Numeric code": 612,
        "Latitude (average)": -24.7,
        "Longitude (average)": -127.4,
        emoji_flag: "🇵🇳"
    },
    PL: {
        Country: "Poland",
        "Alpha-2 code": "PL",
        "Alpha-3 code": "POL",
        "Numeric code": 616,
        "Latitude (average)": 52,
        "Longitude (average)": 20,
        emoji_flag: "🇵🇱"
    },
    PT: {
        Country: "Portugal",
        "Alpha-2 code": "PT",
        "Alpha-3 code": "PRT",
        "Numeric code": 620,
        "Latitude (average)": 39.5,
        "Longitude (average)": -8,
        emoji_flag: "🇵🇹"
    },
    PR: {
        Country: "Puerto Rico",
        "Alpha-2 code": "PR",
        "Alpha-3 code": "PRI",
        "Numeric code": 630,
        "Latitude (average)": 18.25,
        "Longitude (average)": -66.5,
        emoji_flag: "🇵🇷"
    },
    QA: {
        Country: "Qatar",
        "Alpha-2 code": "QA",
        "Alpha-3 code": "QAT",
        "Numeric code": 634,
        "Latitude (average)": 25.5,
        "Longitude (average)": 51.25,
        emoji_flag: "🇶🇦"
    },
    RE: {
        Country: "Réunion",
        "Alpha-2 code": "RE",
        "Alpha-3 code": "REU",
        "Numeric code": 638,
        "Latitude (average)": -21.1,
        "Longitude (average)": 55.6,
        emoji_flag: "🇷🇪"
    },
    RO: {
        Country: "Romania",
        "Alpha-2 code": "RO",
        "Alpha-3 code": "ROU",
        "Numeric code": 642,
        "Latitude (average)": 46,
        "Longitude (average)": 25,
        emoji_flag: "🇷🇴"
    },
    RU: {
        Country: "Russia",
        "Alpha-2 code": "RU",
        "Alpha-3 code": "RUS",
        "Numeric code": 643,
        "Latitude (average)": 60,
        "Longitude (average)": 100,
        emoji_flag: "🇷🇺"
    },
    RW: {
        Country: "Rwanda",
        "Alpha-2 code": "RW",
        "Alpha-3 code": "RWA",
        "Numeric code": 646,
        "Latitude (average)": -2,
        "Longitude (average)": 30,
        emoji_flag: "🇷🇼"
    },
    SH: {
        Country: "Saint Helena, Ascension and Tristan da Cunha",
        "Alpha-2 code": "SH",
        "Alpha-3 code": "SHN",
        "Numeric code": 654,
        "Latitude (average)": -15.9333,
        "Longitude (average)": -5.7,
        emoji_flag: "🇸🇭"
    },
    KN: {
        Country: "Saint Kitts and Nevis",
        "Alpha-2 code": "KN",
        "Alpha-3 code": "KNA",
        "Numeric code": 659,
        "Latitude (average)": 17.3333,
        "Longitude (average)": -62.75,
        emoji_flag: "🇰🇳"
    },
    LC: {
        Country: "Saint Lucia",
        "Alpha-2 code": "LC",
        "Alpha-3 code": "LCA",
        "Numeric code": 662,
        "Latitude (average)": 13.8833,
        "Longitude (average)": -61.1333,
        emoji_flag: "🇱🇨"
    },
    PM: {
        Country: "Saint Pierre and Miquelon",
        "Alpha-2 code": "PM",
        "Alpha-3 code": "SPM",
        "Numeric code": 666,
        "Latitude (average)": 46.8333,
        "Longitude (average)": -56.3333,
        emoji_flag: "🇵🇲"
    },
    VC: {
        Country: "Saint Vincent and the Grenadines",
        "Alpha-2 code": "VC",
        "Alpha-3 code": "VCT",
        "Numeric code": 670,
        "Latitude (average)": 13.25,
        "Longitude (average)": -61.2,
        emoji_flag: "🇻🇨"
    },
    WS: {
        Country: "Samoa",
        "Alpha-2 code": "WS",
        "Alpha-3 code": "WSM",
        "Numeric code": 882,
        "Latitude (average)": -13.5833,
        "Longitude (average)": -172.3333,
        emoji_flag: "🇼🇸"
    },
    SM: {
        Country: "San Marino",
        "Alpha-2 code": "SM",
        "Alpha-3 code": "SMR",
        "Numeric code": 674,
        "Latitude (average)": 43.7667,
        "Longitude (average)": 12.4167,
        emoji_flag: "🇸🇲"
    },
    ST: {
        Country: "Sao Tome and Principe",
        "Alpha-2 code": "ST",
        "Alpha-3 code": "STP",
        "Numeric code": 678,
        "Latitude (average)": 1,
        "Longitude (average)": 7,
        emoji_flag: "🇸🇹"
    },
    SA: {
        Country: "Saudi Arabia",
        "Alpha-2 code": "SA",
        "Alpha-3 code": "SAU",
        "Numeric code": 682,
        "Latitude (average)": 25,
        "Longitude (average)": 45,
        emoji_flag: "🇸🇦"
    },
    SN: {
        Country: "Senegal",
        "Alpha-2 code": "SN",
        "Alpha-3 code": "SEN",
        "Numeric code": 686,
        "Latitude (average)": 14,
        "Longitude (average)": -14,
        emoji_flag: "🇸🇳"
    },
    RS: {
        Country: "Serbia",
        "Alpha-2 code": "RS",
        "Alpha-3 code": "SRB",
        "Numeric code": 688,
        "Latitude (average)": 44,
        "Longitude (average)": 21,
        emoji_flag: "🇷🇸"
    },
    SC: {
        Country: "Seychelles",
        "Alpha-2 code": "SC",
        "Alpha-3 code": "SYC",
        "Numeric code": 690,
        "Latitude (average)": -4.5833,
        "Longitude (average)": 55.6667,
        emoji_flag: "🇸🇨"
    },
    SL: {
        Country: "Sierra Leone",
        "Alpha-2 code": "SL",
        "Alpha-3 code": "SLE",
        "Numeric code": 694,
        "Latitude (average)": 8.5,
        "Longitude (average)": -11.5,
        emoji_flag: "🇸🇱"
    },
    SG: {
        Country: "Singapore",
        "Alpha-2 code": "SG",
        "Alpha-3 code": "SGP",
        "Numeric code": 702,
        "Latitude (average)": 1.3667,
        "Longitude (average)": 103.8,
        emoji_flag: "🇸🇬"
    },
    SK: {
        Country: "Slovakia",
        "Alpha-2 code": "SK",
        "Alpha-3 code": "SVK",
        "Numeric code": 703,
        "Latitude (average)": 48.6667,
        "Longitude (average)": 19.5,
        emoji_flag: "🇸🇰"
    },
    SI: {
        Country: "Slovenia",
        "Alpha-2 code": "SI",
        "Alpha-3 code": "SVN",
        "Numeric code": 705,
        "Latitude (average)": 46,
        "Longitude (average)": 15,
        emoji_flag: "🇸🇮"
    },
    SB: {
        Country: "Solomon Islands",
        "Alpha-2 code": "SB",
        "Alpha-3 code": "SLB",
        "Numeric code": 90,
        "Latitude (average)": -8,
        "Longitude (average)": 159,
        emoji_flag: "🇸🇧"
    },
    SO: {
        Country: "Somalia",
        "Alpha-2 code": "SO",
        "Alpha-3 code": "SOM",
        "Numeric code": 706,
        "Latitude (average)": 10,
        "Longitude (average)": 49,
        emoji_flag: "🇸🇴"
    },
    ZA: {
        Country: "South Africa",
        "Alpha-2 code": "ZA",
        "Alpha-3 code": "ZAF",
        "Numeric code": 710,
        "Latitude (average)": -29,
        "Longitude (average)": 24,
        emoji_flag: "🇿🇦"
    },
    GS: {
        Country: "South Georgia and the South Sandwich Islands",
        "Alpha-2 code": "GS",
        "Alpha-3 code": "SGS",
        "Numeric code": 239,
        "Latitude (average)": -54.5,
        "Longitude (average)": -37,
        emoji_flag: "🇬🇸"
    },
    SS: {
        Country: "South Sudan",
        "Alpha-2 code": "SS",
        "Alpha-3 code": "SSD",
        "Numeric code": 728,
        "Latitude (average)": 8,
        "Longitude (average)": 30,
        emoji_flag: "🇸🇸"
    },
    ES: {
        Country: "Spain",
        "Alpha-2 code": "ES",
        "Alpha-3 code": "ESP",
        "Numeric code": 724,
        "Latitude (average)": 40,
        "Longitude (average)": -4,
        emoji_flag: "🇪🇸"
    },
    LK: {
        Country: "Sri Lanka",
        "Alpha-2 code": "LK",
        "Alpha-3 code": "LKA",
        "Numeric code": 144,
        "Latitude (average)": 7,
        "Longitude (average)": 81,
        emoji_flag: "🇱🇰"
    },
    SD: {
        Country: "Sudan",
        "Alpha-2 code": "SD",
        "Alpha-3 code": "SDN",
        "Numeric code": 736,
        "Latitude (average)": 15,
        "Longitude (average)": 30,
        emoji_flag: "🇸🇩"
    },
    SR: {
        Country: "Suriname",
        "Alpha-2 code": "SR",
        "Alpha-3 code": "SUR",
        "Numeric code": 740,
        "Latitude (average)": 4,
        "Longitude (average)": -56,
        emoji_flag: "🇸🇷"
    },
    SJ: {
        Country: "Svalbard and Jan Mayen",
        "Alpha-2 code": "SJ",
        "Alpha-3 code": "SJM",
        "Numeric code": 744,
        "Latitude (average)": 78,
        "Longitude (average)": 20,
        emoji_flag: "🇸🇯"
    },
    SZ: {
        Country: "Swaziland",
        "Alpha-2 code": "SZ",
        "Alpha-3 code": "SWZ",
        "Numeric code": 748,
        "Latitude (average)": -26.5,
        "Longitude (average)": 31.5,
        emoji_flag: "🇸🇿"
    },
    SE: {
        Country: "Sweden",
        "Alpha-2 code": "SE",
        "Alpha-3 code": "SWE",
        "Numeric code": 752,
        "Latitude (average)": 62,
        "Longitude (average)": 15,
        emoji_flag: "🇸🇪"
    },
    CH: {
        Country: "Switzerland",
        "Alpha-2 code": "CH",
        "Alpha-3 code": "CHE",
        "Numeric code": 756,
        "Latitude (average)": 47,
        "Longitude (average)": 8,
        emoji_flag: "🇨🇭"
    },
    SY: {
        Country: "Syrian Arab Republic",
        "Alpha-2 code": "SY",
        "Alpha-3 code": "SYR",
        "Numeric code": 760,
        "Latitude (average)": 35,
        "Longitude (average)": 38,
        emoji_flag: "🇸🇾"
    },
    TW: {
        Country: "Taiwan",
        "Alpha-2 code": "TW",
        "Alpha-3 code": "TWN",
        "Numeric code": 158,
        "Latitude (average)": 23.5,
        "Longitude (average)": 121,
        emoji_flag: "🇹🇼"
    },
    TJ: {
        Country: "Tajikistan",
        "Alpha-2 code": "TJ",
        "Alpha-3 code": "TJK",
        "Numeric code": 762,
        "Latitude (average)": 39,
        "Longitude (average)": 71,
        emoji_flag: "🇹🇯"
    },
    TZ: {
        Country: "Tanzania, United Republic of",
        "Alpha-2 code": "TZ",
        "Alpha-3 code": "TZA",
        "Numeric code": 834,
        "Latitude (average)": -6,
        "Longitude (average)": 35,
        emoji_flag: "🇹🇿"
    },
    TH: {
        Country: "Thailand",
        "Alpha-2 code": "TH",
        "Alpha-3 code": "THA",
        "Numeric code": 764,
        "Latitude (average)": 15,
        "Longitude (average)": 100,
        emoji_flag: "🇹🇭"
    },
    TL: {
        Country: "Timor-Leste",
        "Alpha-2 code": "TL",
        "Alpha-3 code": "TLS",
        "Numeric code": 626,
        "Latitude (average)": -8.55,
        "Longitude (average)": 125.5167,
        emoji_flag: "🇹🇱"
    },
    TG: {
        Country: "Togo",
        "Alpha-2 code": "TG",
        "Alpha-3 code": "TGO",
        "Numeric code": 768,
        "Latitude (average)": 8,
        "Longitude (average)": 1.1667,
        emoji_flag: "🇹🇬"
    },
    TK: {
        Country: "Tokelau",
        "Alpha-2 code": "TK",
        "Alpha-3 code": "TKL",
        "Numeric code": 772,
        "Latitude (average)": -9,
        "Longitude (average)": -172,
        emoji_flag: "🇹🇰"
    },
    TO: {
        Country: "Tonga",
        "Alpha-2 code": "TO",
        "Alpha-3 code": "TON",
        "Numeric code": 776,
        "Latitude (average)": -20,
        "Longitude (average)": -175,
        emoji_flag: "🇹🇴"
    },
    TT: {
        Country: "Trinidad and Tobago",
        "Alpha-2 code": "TT",
        "Alpha-3 code": "TTO",
        "Numeric code": 780,
        "Latitude (average)": 11,
        "Longitude (average)": -61,
        emoji_flag: "🇹🇹"
    },
    TN: {
        Country: "Tunisia",
        "Alpha-2 code": "TN",
        "Alpha-3 code": "TUN",
        "Numeric code": 788,
        "Latitude (average)": 34,
        "Longitude (average)": 9,
        emoji_flag: "🇹🇳"
    },
    TR: {
        Country: "Turkey",
        "Alpha-2 code": "TR",
        "Alpha-3 code": "TUR",
        "Numeric code": 792,
        "Latitude (average)": 39,
        "Longitude (average)": 35,
        emoji_flag: "🇹🇷"
    },
    TM: {
        Country: "Turkmenistan",
        "Alpha-2 code": "TM",
        "Alpha-3 code": "TKM",
        "Numeric code": 795,
        "Latitude (average)": 40,
        "Longitude (average)": 60,
        emoji_flag: "🇹🇲"
    },
    TC: {
        Country: "Turks and Caicos Islands",
        "Alpha-2 code": "TC",
        "Alpha-3 code": "TCA",
        "Numeric code": 796,
        "Latitude (average)": 21.75,
        "Longitude (average)": -71.5833,
        emoji_flag: "🇹🇨"
    },
    TV: {
        Country: "Tuvalu",
        "Alpha-2 code": "TV",
        "Alpha-3 code": "TUV",
        "Numeric code": 798,
        "Latitude (average)": -8,
        "Longitude (average)": 178,
        emoji_flag: "🇹🇻"
    },
    UG: {
        Country: "Uganda",
        "Alpha-2 code": "UG",
        "Alpha-3 code": "UGA",
        "Numeric code": 800,
        "Latitude (average)": 1,
        "Longitude (average)": 32,
        emoji_flag: "🇺🇬"
    },
    UA: {
        Country: "Ukraine",
        "Alpha-2 code": "UA",
        "Alpha-3 code": "UKR",
        "Numeric code": 804,
        "Latitude (average)": 49,
        "Longitude (average)": 32,
        emoji_flag: "🇺🇦"
    },
    AE: {
        Country: "United Arab Emirates",
        "Alpha-2 code": "AE",
        "Alpha-3 code": "ARE",
        "Numeric code": 784,
        "Latitude (average)": 24,
        "Longitude (average)": 54,
        emoji_flag: "🇦🇪"
    },
    GB: {
        Country: "United Kingdom",
        "Alpha-2 code": "GB",
        "Alpha-3 code": "GBR",
        "Numeric code": 826,
        "Latitude (average)": 54,
        "Longitude (average)": -2,
        emoji_flag: "🇬🇧"
    },
    US: {
        Country: "United States",
        "Alpha-2 code": "US",
        "Alpha-3 code": "USA",
        "Numeric code": 840,
        "Latitude (average)": 38,
        "Longitude (average)": -97,
        emoji_flag: "🇺🇸"
    },
    UM: {
        Country: "United States Minor Outlying Islands",
        "Alpha-2 code": "UM",
        "Alpha-3 code": "UMI",
        "Numeric code": 581,
        "Latitude (average)": 19.2833,
        "Longitude (average)": 166.6,
        emoji_flag: "🇺🇲"
    },
    UY: {
        Country: "Uruguay",
        "Alpha-2 code": "UY",
        "Alpha-3 code": "URY",
        "Numeric code": 858,
        "Latitude (average)": -33,
        "Longitude (average)": -56,
        emoji_flag: "🇺🇾"
    },
    UZ: {
        Country: "Uzbekistan",
        "Alpha-2 code": "UZ",
        "Alpha-3 code": "UZB",
        "Numeric code": 860,
        "Latitude (average)": 41,
        "Longitude (average)": 64,
        emoji_flag: "🇺🇿"
    },
    VU: {
        Country: "Vanuatu",
        "Alpha-2 code": "VU",
        "Alpha-3 code": "VUT",
        "Numeric code": 548,
        "Latitude (average)": -16,
        "Longitude (average)": 167,
        emoji_flag: "🇻🇺"
    },
    VE: {
        Country: "Venezuela",
        "Alpha-2 code": "VE",
        "Alpha-3 code": "VEN",
        "Numeric code": 862,
        "Latitude (average)": 8,
        "Longitude (average)": -66,
        emoji_flag: "🇻🇪"
    },
    VN: {
        Country: "Vietnam",
        "Alpha-2 code": "VN",
        "Alpha-3 code": "VNM",
        "Numeric code": 704,
        "Latitude (average)": 16,
        "Longitude (average)": 106,
        emoji_flag: "🇻🇳"
    },
    VG: {
        Country: "Virgin Islands, British",
        "Alpha-2 code": "VG",
        "Alpha-3 code": "VGB",
        "Numeric code": 92,
        "Latitude (average)": 18.5,
        "Longitude (average)": -64.5,
        emoji_flag: "🇻🇬"
    },
    VI: {
        Country: "Virgin Islands, U.S.",
        "Alpha-2 code": "VI",
        "Alpha-3 code": "VIR",
        "Numeric code": 850,
        "Latitude (average)": 18.3333,
        "Longitude (average)": -64.8333,
        emoji_flag: "🇻🇮"
    },
    WF: {
        Country: "Wallis and Futuna",
        "Alpha-2 code": "WF",
        "Alpha-3 code": "WLF",
        "Numeric code": 876,
        "Latitude (average)": -13.3,
        "Longitude (average)": -176.2,
        emoji_flag: "🇼🇫"
    },
    EH: {
        Country: "Western Sahara",
        "Alpha-2 code": "EH",
        "Alpha-3 code": "ESH",
        "Numeric code": 732,
        "Latitude (average)": 24.5,
        "Longitude (average)": -13,
        emoji_flag: "🇪🇭"
    },
    YE: {
        Country: "Yemen",
        "Alpha-2 code": "YE",
        "Alpha-3 code": "YEM",
        "Numeric code": 887,
        "Latitude (average)": 15,
        "Longitude (average)": 48,
        emoji_flag: "🇾🇪"
    },
    ZM: {
        Country: "Zambia",
        "Alpha-2 code": "ZM",
        "Alpha-3 code": "ZMB",
        "Numeric code": 894,
        "Latitude (average)": -15,
        "Longitude (average)": 30,
        emoji_flag: "🇿🇲"
    },
    ZW: {
        Country: "Zimbabwe",
        "Alpha-2 code": "ZW",
        "Alpha-3 code": "ZWE",
        "Numeric code": 716,
        "Latitude (average)": -20,
        "Longitude (average)": 30,
        emoji_flag: "🇿🇼"
    },
    AX: {
        Country: "Åland Islands",
        "Alpha-2 code": "AX",
        "Alpha-3 code": "ALA",
        "Numeric code": 248,
        "Latitude (average)": 60.116667,
        "Longitude (average)": 19.9,
        emoji_flag: "🇦🇽"
    },
    BQ: {
        Country: "Bonaire, Sint Eustatius and Saba",
        "Alpha-2 code": "BQ",
        "Alpha-3 code": "BES",
        "Numeric code": 535,
        "Latitude (average)": 12.183333,
        "Longitude (average)": -68.233333,
        emoji_flag: "🇧🇶"
    },
    CW: {
        Country: "Curaçao",
        "Alpha-2 code": "CW",
        "Alpha-3 code": "CUW",
        "Numeric code": 531,
        "Latitude (average)": 12.166667,
        "Longitude (average)": -68.966667,
        emoji_flag: "🇨🇼"
    },
    BL: {
        Country: "Saint Barthélemy",
        "Alpha-2 code": "BL",
        "Alpha-3 code": "BLM",
        "Numeric code": 652,
        "Latitude (average)": 17.897728,
        "Longitude (average)": -62.834244,
        emoji_flag: "🇧🇱"
    },
    MF: {
        Country: "Saint Martin (French part)",
        "Alpha-2 code": "MF",
        "Alpha-3 code": "MAF",
        "Numeric code": 663,
        "Latitude (average)": 18.075278,
        "Longitude (average)": -63.06,
        emoji_flag: "🇲🇫"
    },
    SX: {
        Country: "Sint Maarten (Dutch part)",
        "Alpha-2 code": "SX",
        "Alpha-3 code": "SXM",
        "Numeric code": 534,
        "Latitude (average)": 18.033333,
        "Longitude (average)": -63.05,
        emoji_flag: "🇸🇽"
    },
    XK: {
        Country: "Kosovo",
        "Alpha-2 code": "XK",
        "Alpha-3 code": "XKX",
        "Numeric code": -1,
        "Latitude (average)": 42.583333,
        "Longitude (average)": 21,
        emoji_flag: "🇽🇰"
    }
};
